import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useT } from '../locales';

export function NotFoundPage() {
  const t = useT();
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle={t('error.notFound')}
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          {t('noAccess.goHome')}
        </Button>
      }
    />
  );
}
